import React from 'react';
import { strings } from '../../../resources/strings';
import { IFilterToListLocationsOutput, YesNoFilter, yesNoFilterOptions } from '../locationUi';
import { Container, Filter, FilterName, FilterValue, Title, Filters } from './styles';

interface IFiltersProps {
  appliedFilters?: IFilterToListLocationsOutput;
  marginTop?: string;
}

const AppliedFiltersToListLocations: React.FC<IFiltersProps> = ({
  appliedFilters,
  marginTop
}) => {

  const renderFilter = (name: string, value?: string | null) => {
    if (!value) return null;

    return (
      <Filter>
        <FilterName>{name}: </FilterName>
        <FilterValue>{value}</FilterValue>
      </Filter>
    );
  }

  // "Todas" não é exibido
  const getYesNoText = (value?: YesNoFilter) =>
    value && value !== YesNoFilter.All
      ? yesNoFilterOptions.find(option => option.key === value)?.text
      : undefined;

  return (
    <Container marginTop={marginTop}>
      <Title>{strings.AppliedFilters}</Title>
      <Filters>
        {renderFilter('Nome ou ID Shopify', appliedFilters?.text)}
        {renderFilter('Omnichannel', getYesNoText(appliedFilters?.omnichannel))}
        {renderFilter('Usa Sislog', getYesNoText(appliedFilters?.manageOrderInSislog))}
        {renderFilter('Comunicação transacional ativa', getYesNoText(appliedFilters?.transactionalCommunication))}
      </Filters>
    </Container>
  );
}

export { AppliedFiltersToListLocations };
